export const isNullOrWhitespace = (str) => {
    return str == null || str.match(/^ *$/) !== null;
}

export const isValidEmail = (email) => {
    return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
};